import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
export const AddUserDialogWrapper = styled(Dialog)`
  height: 100%;
  .customDialogTitle {
    background-color: #1b4a83;
    text-align: center;
    color: #fff;
  }
  .customDialog {
    text-align: center;
    color: #000;
    img {
      display: block;
      margin: 10px auto; /* Center the image horizontally */
      max-width: 100px; /* Set the desired max width for the image */
    }
    .note {
      width: 70%;
      text-align: left;
      font-weight: 700;
      padding-left: 20px;
    }
    .customDropdown {
      text-align: left;
      width: 100%;
    }
    span.error {
      color: #d32f2f;
      line-height: 2;
      font-weight: 400;
    }
    span.red {
      color: #ff0000;
      font-weight: 600;

    }
    .errorInput {
      border: 1px solid #ff0000;
      border-radius: 5px;
    }
    .field {
      width: 50%;
      .Mui-disabled {
        color: black;
        -webkit-text-fill-color: black;
      }
    }
    .fetchfield {
      width: 50%;
      padding-top: 25px;
    }
    .inputform {
      display: flex;
      width: 100%;
      padding-top: 30px;
      gap: 40px;
      text-align: start;
      align-items: start;
      .formValue {
        width: 100%;
      }
    }
  }
  .textfieldbg{
    background-color: rgb(228, 228, 228);
  }
  .dialogbutton {
    text-align: center;
    display: flex;
    gap: 40px;
    justify-content: center;
    margin-bottom: 30px;

    .confirmButton {
      text-align: center;
      text-transform: none;
      width: 10%;
    }
    .rightButton {
      text-align: center;
      text-transform: none;
      color: #1b4a83;
      width: 10%;
      border-color: #1b4a83;
    }
  }
  .fetchButton {
    text-align: center;
    text-transform: none;
    width: 100%;
    height: 40px;
    color: #1b4a83;
    border-color: #1b4a83;
  }
  .error {
    color: #d32f2f;
    font-size: 12px;
    margin-top: 2px;
  }
  .MuiFormHelperText-root{
    margin-left: 0px;
  }
`;
